import React from "react";
import { useTranslation } from "react-i18next";

function ReferralInviteModal({
  email,
  error,
  isSending,
  message,
  onChangeEmail,
  onClose,
  onSubmit,
}) {
  const { t } = useTranslation();

  return (
    <div className="t-fixed t-inset-0 t-z-50 t-flex t-items-center t-justify-center t-bg-black/40 t-p-4">
      <div className="t-w-full t-max-w-md t-rounded-lg t-bg-white t-p-6 t-shadow-xl">
        <div className="t-flex t-items-start t-justify-between t-gap-4">
          <div>
            <h2 className="t-m-0 t-font-sans t-text-xl t-font-bold t-text-tertiary">
              {t("ReferralPage_EmailModalTitle")}
            </h2>
            <p className="t-mt-2 t-font-sans t-text-sm t-font-semibold t-text-gray-500">
              {t("ReferralPage_EmailModalBody")}
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="t-rounded-lg t-border t-border-gray-200 t-bg-white t-px-3 t-py-1 t-font-sans t-text-lg t-font-bold t-text-gray-500"
          >
            x
          </button>
        </div>

        <form onSubmit={onSubmit} className="t-mt-5 t-flex t-flex-col t-gap-4">
          <label className="t-font-sans t-text-sm t-font-bold t-text-gray-600">
            {t("ReferralPage_EmailLabel")}
          </label>
          <input
            type="email"
            value={email}
            onChange={(event) => onChangeEmail(event.target.value)}
            placeholder={t("ReferralPage_EmailPlaceholder")}
            className="t-rounded-lg t-border t-border-gray-200 t-px-4 t-py-3 t-font-sans t-text-sm t-text-gray-700 focus:t-border-tertiary focus:t-outline-none"
          />
          {message && (
            <p className="t-m-0 t-font-sans t-text-sm t-font-bold t-text-green-600">
              {message}
            </p>
          )}
          {error && (
            <p className="t-m-0 t-font-sans t-text-sm t-font-bold t-text-red-600">
              {error}
            </p>
          )}
          <div className="t-flex t-flex-col-reverse t-gap-3 sm:t-flex-row sm:t-justify-end">
            <button
              type="button"
              onClick={onClose}
              className="t-rounded-lg t-border t-border-gray-200 t-bg-white t-px-5 t-py-3 t-font-sans t-text-sm t-font-bold t-text-tertiary"
            >
              {t("ReferralPage_EmailCancel")}
            </button>
            <button
              type="submit"
              disabled={isSending}
              className="t-rounded-lg t-bg-tertiary t-px-5 t-py-3 t-font-sans t-text-sm t-font-bold t-text-white disabled:t-cursor-not-allowed disabled:t-opacity-60"
            >
              {isSending ? t("Loading") : t("ReferralPage_EmailSend")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ReferralInviteModal;
